import {ForestMassSpeciesEdit} from '@/admin/resources/forestMassSpecies/ForestMassSpecies';

export default {
  edit: ForestMassSpeciesEdit,
};
